/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */

export class RequestBase {
  public getAPIEndPoint(): string {
    return '';
  }
}
